/* Sacrasoul homepage — one scroll reveal for all hp-* sections.
   Visible-by-default: CSS only hides [data-hpr] under html.hp-js + motion-ok,
   so no JS / no IO / reduced-motion all degrade to a fully visible page. */
(function () {
  /* Defensive singleton: theme-editor section reloads or stale cached markup
     must never create duplicate observers or document-level click handlers. */
  if (window.__sacrasoulHpHomeReady) return;
  window.__sacrasoulHpHomeReady = true;
  if (!('IntersectionObserver' in window)) {
    document.documentElement.classList.remove('hp-js');
    return;
  }
  var seen = new WeakSet();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('hp-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
  function scan() {
    document.querySelectorAll('.hp [data-hpr]').forEach(function (el) {
      if (!seen.has(el)) { seen.add(el); io.observe(el); }
    });
  }
  scan();
  /* Shopify theme editor re-renders sections; re-scan on section load. */
  document.addEventListener('shopify:section:load', scan);

  /* ── Warm the curator's three illustrations ───────────────────────────────
     Sho: "it takes one second for the icons in the curator's note to load up."

     Measured on the preview at 390x844 under a throttled 3G profile: the three
     .hps-mic webp files start fetching at 2,229ms and finish at 2,706-2,740ms
     — about half a second for three files that weigh 8.6, 11.1 and 12.8 KB in
     total. The card's own reveal is instant once it is scrolled to (measured
     81ms to full opacity), so the second Sho sees is purely the download.
     They are loading="lazy" and sit ~1,800px down the page, so the browser
     only starts them as they come near the viewport and the arrival is always
     visible.

     Total cost of removing that: 31.6 KB, which is less than one resin
     thumbnail (82px, ~59 KB at the size the gallery requests). It is fetched
     when the browser is idle, after the page has settled, so it cannot
     compete with the LCP image. Same reasoning, and the same shape, as the
     cart drawer's measured idle warm.

     The <img loading="lazy"> stays exactly as it is: this only puts the bytes
     in the cache earlier. If the warm never runs — no requestIdleCallback, a
     slow connection, data saver — the images load exactly as they do today. */
  function warmCurator() {
    if (!document.querySelector('.hps-curator')) return;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
    document.querySelectorAll('.hps-mic').forEach(function (img) {
      var url = img.getAttribute('src');
      if (!url) return;
      var warm = new Image();
      warm.decoding = 'async';
      warm.src = url;
    });
  }
  /* Armed on `load`, THEN idle. It used to arm idle immediately, which on a
     fresh navigation reached these three illustrations at 3.61s while the hero
     poster was still downloading and did not finish until 5.14s: 31,582 encoded
     bytes of below-fold art competing with the LCP element for a phone's
     bandwidth. Waiting for `load` costs nothing here - the warm cannot help
     first paint either way - and takes 31.6 KB off the critical window.
     Measured on the live homepage, 2026-09-11. */
  function armWarm() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warmCurator, { timeout: 2500 });
    } else {
      setTimeout(warmCurator, 200);
    }
  }
  if (document.readyState === 'complete') armWarm();
  else addEventListener('load', armWarm, { once: true });
})();

/* The story rail's hint is a button: a tap slides the rail one plate along, and
   wraps to the first plate from the last. It used to be a <span> with an arrow,
   which people tapped (PostHog dead clicks, 30 days to 2026-09-10).

   It scrolls TO the next plate's snap position, never BY a plate's width. The
   plates snap to centre, and the rail can only scroll 0..570px at 390, so their
   snap positions are 0, 285 and 570 while plate + gap is 313. Chromium snapped a
   313px step back to 285; WebKit snaps a programmatic step forward to the next
   point past it, so on Safari a tap went i -> iii -> i and plate ii never showed
   (measured 2026-10-30, live PL homepage, 390x844). Landing exactly on the
   position leaves neither engine anything to round. Reduced motion jumps.

   A second tap during the glide steps on from where the first one is going,
   not from where the rail happens to be: read mid-animation, scrollLeft sat
   short of the next position and two quick taps moved one plate (review,
   2026-10-31). The target is kept for 600ms, longer than the glide (213 to
   413ms headless in Chromium and WebKit, the longest being the wrap), and
   dropped the moment a finger or pointer takes the rail itself. */
document.addEventListener('pointerdown', function (e) {
  var rail = e.target.closest && e.target.closest('.hps-plates');
  if (rail) rail._ssHintAt = 0;
}, { passive: true });
document.addEventListener('click', function (e) {
  var hint = e.target.closest('.hps-railhint');
  if (!hint) return;
  var wrap = hint.closest('.hps-railwrap');
  var rail = wrap && wrap.querySelector('.hps-plates');
  var plates = rail ? rail.querySelectorAll('.hps-plate') : [];
  if (!plates.length) return;
  var max = rail.scrollWidth - rail.clientWidth;
  var box = rail.getBoundingClientRect();
  var spots = Array.prototype.map.call(plates, function (p) {
    var r = p.getBoundingClientRect();
    var centre = r.left - box.left + rail.scrollLeft + r.width / 2 - rail.clientWidth / 2;
    return Math.max(0, Math.min(max, Math.round(centre)));
  });
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var now = Date.now();
  var from = !still && now - (rail._ssHintAt || 0) < 600 ? rail._ssHintTo : rail.scrollLeft;
  // the first snap position clearly past where the rail rests (or is going); none left means wrap
  var to = 0;
  for (var i = 0; i < spots.length; i++) {
    if (spots[i] > from + 4) { to = spots[i]; break; }
  }
  rail._ssHintTo = to;
  rail._ssHintAt = now;
  rail.scrollTo({ left: to, behavior: still ? 'auto' : 'smooth' });
});

/* Sets quick-add → SacrasoulCart.addAndOpen (optimistic preview from data-attrs) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.hp-qadd');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  var id = btn.dataset.variantId, label = btn.querySelector('.hp-qadd__label');
  var api = window.SacrasoulCart;
  if (!id) return;
  /* keep the market: a bare '/cart' from /de-eu/ lands in the UK storefront (#2393) */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (!api || !api.addAndOpen) { window.location.href = btn.dataset.productUrl || (root.charAt(root.length - 1) === '/' ? root : root + '/') + 'cart'; return; }
  /* stay clickable: a second tap queues another unit (the engine serializes
     adds); the label follows the last settlement */
  btn._ssInflight = (btn._ssInflight || 0) + 1;
  label.textContent = btn.dataset.labelAdding;
  var preview = api.buildPreview ? api.buildPreview(btn, id, 1) : null;
  Promise.resolve(api.addAndOpen(id, 1, undefined, preview, undefined, { quiet: true, origin: btn }))
    .then(function () {
      btn._ssInflight -= 1;
      if (btn._ssInflight > 0) return;
      btn.classList.add('is-added'); label.textContent = btn.dataset.labelAdded;
    })
    .catch(function () { btn._ssInflight = Math.max(0, btn._ssInflight - 1); })
    .then(function () {
      setTimeout(function () {
        if (btn._ssInflight > 0) return;
        btn.classList.remove('is-added'); label.textContent = btn.dataset.label;
      }, 2000);
    });
});
